import { IKeySideName, IKeysModalsCommon } from "../../../../store/keysTypes";
import Button from "../../../UI/Button";
import ZusammenfassungItem from "./ZusammenfassungItem";
import plusSvg from "../../../../assets/img/plus.svg";
import { useEffect } from "react";
import { Box, styled } from "@mui/material";
import { SCROLL_CSS } from "../../../../constants/common";
import { ZusammenfassungSelectorParameters } from "../styles";
import { IKeysBlankNames } from "../../../../constants/pragerohlinge";
import { useTranslation } from "react-i18next";
import { useKeyCustomization } from "../../../../hooks/useKeyCustomization";
import { useKeysModal } from "../../../../hooks/useKeysModal";
import { useKeysPagination } from "../../../../hooks/useKeysPagination";

const Wrapper = styled(Box)`
  position: relative;
  padding-top 5px;
  width: 100%;

  .draggable-item {
    display: flex;
  }

  .draggable-item__drag {
    align-items: center;
    margin-left: auto;
    margin-bottom: 8px;
  }
`;

const WrapperInner = styled(Box)`
  min-height: 360px;
  max-height: 440px;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 4px;

  ${SCROLL_CSS};

  ${({ theme }) => theme.breakpoints.down("md")} {
    max-height: unset;
    min-height: unset;
    width: unset;
    padding-right: 0;
    display: block;
  }
`;

const Title = styled("span")`
  ${({ theme }) => theme.breakpoints.down("md")} {
    display: none;
  }
`;

const ZusammenfassungParameters = () => {
  const {
    selectedKeyTypes: keys,
    updateKeyProperty,
    setSelectedKeyId,
  } = useKeyCustomization();
  const { openModal } = useKeysModal();
  const { onChangeTab } = useKeysPagination();
  const { t } = useTranslation();

  useEffect(() => {
    if (!Object.values(keys).flat().length) {
      onChangeTab(1);
    }
  }, [keys]);

  const handleChangeSelect = (
    value: string,
    index: number,
    blank: IKeysBlankNames
  ) => {
    updateKeyProperty({ keyIndex: index, blank, property: "menge", value });
  };

  const handleScreenShot = (index: number, blank: IKeysBlankNames) => {
    return (side: IKeySideName, value: string) =>
      updateKeyProperty({
        keyIndex: index,
        blank,
        side,
        property: "image",
        value,
      });
  };

  const handleClickTooltip = (value: IKeysModalsCommon, blank: string) => {
    openModal(value, { type: blank });
  };

  const handleClickEdit = (id: string) => {
    setSelectedKeyId(id);
    onChangeTab(2);
  };

  const handleClickDelete = (id: string) => {
    openModal(IKeysModalsCommon.MODAL_DELETE_KEY, { id });
  };

  const handleClickMoreButton = () => {
    onChangeTab(1);
  };

  return (
    <>
      <WrapperInner>
        <Title>{t("key-summary.amount-text")}</Title>
        <Box>
          {Object.entries(keys)
            .filter(([blank, value]) => value.length)
            .map(([blank, value]) => (
              <ZusammenfassungSelectorParameters key={blank}>
                <Box>
                  {value.map((item, index) => (
                    <ZusammenfassungItem
                      _key={item}
                      key={item.id}
                      name={item.name}
                      menge={item.menge}
                      blank={item.blank}
                      profile={item.value}
                      value={item.value}
                      front={item.front}
                      back={item.back}
                      onChangeMenge={(value) =>
                        handleChangeSelect(
                          value as string,
                          index,
                          blank as IKeysBlankNames
                        )
                      }
                      onScreenShot={(side: IKeySideName, value: string) => {
                        const handler = handleScreenShot(index, item.blank);
                        handler(side, value);
                      }}
                      onClickTooltip={handleClickTooltip}
                      onClickDelete={() => handleClickDelete(item.id)}
                      onClickEdit={() => handleClickEdit(item.id)}
                    />
                  ))}
                </Box>
              </ZusammenfassungSelectorParameters>
            ))}
        </Box>
        <Button
          variant="second"
          sx={{
            padding: "8px",
            minWidth: "40px",
            marginRight: "8px",
            background: "transparent",
          }}
          onClick={handleClickMoreButton}
        >
          <img src={plusSvg} alt="(i)" />
        </Button>
      </WrapperInner>
      <Box
        sx={{
          position: "absolute",
          bottom: "100%",
          right: "0",
          fontWeight: 500,
          fontSize: "14px",
        }}
      >
        {t("key-summary.amount-text")}
      </Box>
    </>
  );
};

export default ZusammenfassungParameters;
